import { useEffect } from 'react';
import { scrollbarTokens } from './scrollbar-properties.js';

let activeLocks = 0;

/**
 * Disables scrolling on the main body layer as soon as at least one component
 * requests it.
 * This is useful when e.g. overlays are open and we want to disable scrolling
 * on the main layer.
 */
function useScrollLocking(enabled) {
  useEffect(() => {
    if (enabled) {
      onLockStateChange(++activeLocks);
    }
    return () => {
      if (enabled) {
        onLockStateChange(--activeLocks);
      }
    };
  }, [enabled]);
}
function onLockStateChange(lockCount) {
  if (lockCount > 0) {
    document.body.style.setProperty("--removed-body-scroll-bar-size", scrollbarTokens.width());
    document.body.style.setProperty("margin-right", scrollbarTokens.width());
    document.body.style.setProperty("overflow", "hidden", "important");
  } else {
    document.body.style.setProperty("--removed-body-scroll-bar-size", "");
    document.body.style.setProperty("margin-right", "");
    document.body.style.setProperty("overflow", null);
  }
}

export { useScrollLocking };
//# sourceMappingURL=useScrollLocking.js.map
